import { useDispatch, useSelector } from "react-redux"
import { changeStatus, onFetchPaymentVouchers, onFetchTotalRows, selectPaymentVoucherState } from "../redux/slices/paymentVoucherSlice"
import { ApiStatus } from "../types/api/status"
import { PaymentVoucherAPI } from "../apis/PaymentVoucherAPI"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"

export const usePaymentVoucherStore = () => {
    const dispatch = useDispatch()
    const { paymentVouchers, paymentVoucherSelected, status, totalRows } = useSelector(selectPaymentVoucherState)

    const getPaymentVouchers = async (data?: object) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await PaymentVoucherAPI.get(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            const { detail, total } = response.data
            dispatch(onFetchPaymentVouchers(detail || []))
            dispatch(onFetchTotalRows(total || 0))
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const cancelPaymentVoucher = async (id: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await PaymentVoucherAPI.cancel(id)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    // const createPaymentVoucher = async (data: object) => {
    //     try {
    //         dispatch(changeStatus(ApiStatus.FETCHING))
    //         const response = await PaymentVoucherAPI.create(data)
    //         if (!response?.status) {
    //             dispatch(changeStatus(ApiStatus.FETCHED))
    //             CustomSnackbar('error', response.data.message || "");
    //             return false;
    //         }
    //         const { detail } = response.data
    //         dispatch(changeStatus(ApiStatus.FETCHED))
    //         return detail;
    //     } catch (error) {
    //         console.log(error)
    //         return dispatch(changeStatus(ApiStatus.FETCHED))
    //     }
    // }

    // const updateQuantity = async (id: number, data: object) => {
    //     try {
    //         dispatch(changeStatus(ApiStatus.FETCHING))
    //         const response = await PaymentVoucherAPI.updateQuantity(id, data)
    //         if (!response?.status) {
    //             dispatch(changeStatus(ApiStatus.FETCHED))
    //             CustomSnackbar('error', response.data.message || "");
    //             return false;
    //         }
    //         const { detail } = response.data
    //         dispatch(changeStatus(ApiStatus.FETCHED))
    //         return detail;
    //     } catch (error) {
    //         console.log(error)
    //         return dispatch(changeStatus(ApiStatus.FETCHED))
    //     }
    // }

    // const deleteProductCart = async (id: number) => {
    //     try {
    //         dispatch(changeStatus(ApiStatus.FETCHING))
    //         const response = await PaymentVoucherAPI.delete(id)
    //         if (!response?.status) {
    //             dispatch(changeStatus(ApiStatus.FETCHED))
    //             CustomSnackbar('error', response.data.message || "");
    //             return false;
    //         }
    //         const { detail } = response.data
    //         dispatch(changeStatus(ApiStatus.FETCHED))
    //         return detail;
    //     } catch (error) {
    //         console.log(error)
    //         return dispatch(changeStatus(ApiStatus.FETCHED))
    //     }
    // }

    const clearPaymentVoucher = () => {
        try {
            dispatch(onFetchPaymentVouchers([]))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        paymentVouchers,
        paymentVoucherSelected,
        status,
        totalRows,
        getPaymentVouchers,
        // createPaymentVoucher,
        // updateQuantity,
        // deleteProductCart,
        clearPaymentVoucher,
        cancelPaymentVoucher
    }
}